import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { EventsFilter } from '../../interfaces';
import { selectFleet } from '../../selectors';
import { EventsService } from '../../services';
import { basic } from '../../theme/colors';
import { useInterval } from '../../hooks/useInterval';

interface Props {
  filter: EventsFilter;
  className?: string;
}

const interval: ReturnType<typeof setInterval> = null;

export function EventsCounter(props: Props) {
  const [count, setCount] = useState<number>(-1);
  const fleet = useSelector(selectFleet);

  const refreshCount = () => EventsService.getCount(props.filter, fleet).then(setCount);

  // periodically refresh the count with some variance in case theres multiple components
  useInterval(refreshCount, (60 * 5 + Math.random() * 10) * 1000)

  // we can revisit this when we have a better method. this is for the count badge on the nav bar
  // currently it fires multiple times.
  useEffect(() => {
    // refreshCount();
  }, [props.filter, fleet]);

  if (count <= 0) {
    return null;
  }

  return <Badge className={props.className}>{count < 100 ? count : '99+'}</Badge>;
}

const Badge = styled.div`
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  display: inline-block;
  vertical-align: middle;
  border-radius: 1em;
  color: white;
  background: ${basic.haydenBrand};
  font-size: 1rem;
  border-radius: 100%;
  text-align: center;
  vertical-align: middle;
  position: relative;
  top: -1px;
  margin-left: 0.5em;
`;
